import React from 'react';
import { useTranslation } from 'react-i18next';

import translations from 'services/translations/translations';

const TranslatedOption = ({
  element,
  translationFile,
  section,
}: {
  element: string;
  translationFile: string;
  section: string;
}): JSX.Element => {
  const { t } = useTranslation([
    translations.common,
    translations.glassWallDoorProperties,
    translations.glassWallGlassProperties,
    translations.glassWallProperties,
    translations.woodyWallProperties,
  ]);

  const sectionWithSeparator = section === '' ? '' : `:${section}`;

  return (
    <option key={`opt ${element}`} value={element}>
      {t(`${translationFile}${sectionWithSeparator}:${element}`)}
    </option>
  );
};

export default TranslatedOption;
